<template>
    <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">
        <a-form-item label="版本">
            <a-select v-model="searchP.version" placeholder="" style="width: 80px">
                <a-select-option value=""> 全部 </a-select-option>
                <a-select-option value="V3.0"> 3.0 </a-select-option>
                <a-select-option value="V5.0"> 5.0 </a-select-option>
            </a-select>
        </a-form-item>

        <a-form-item label="所属领域">
            <a-select v-model="searchP.domain" style="width: 80px">
                <a-select-option value="001">前台</a-select-option>
                <a-select-option value="002">中台</a-select-option>
                <a-select-option value="003">开放</a-select-option>
                <a-select-option value="004">基础</a-select-option>
            </a-select>
        </a-form-item>

        <a-form-item label="关键字">
            <a-input v-model="searchP.keyword" placeholder="关键字" allow-clear ></a-input>
        </a-form-item>

        <a-form-item>
            <a-button type="primary" @click="handleSubmit">查询</a-button>
        </a-form-item>
    </a-form>
</template>

<script>

export default {
    components:{
    },
    data(){
        return {
            form: this.$form.createForm(this),
            searchP:{
                version:'',
                domain:'001',
                keyword:''
            }
        }
    },
    methods:{
        handleSubmit(){
            this.$emit("handleSearch",this.searchP);
        },
      
    },
    mounted(){
        this.handleSubmit();
    }
}

</script>

<style>
    .myform{
        margin-bottom: 20px;
    }
</style>

